import { Chip, Divider, MenuItem, MenuList } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useGlobalTimeSliderContext } from '../../../context/contexts';
import { enumKeys } from '../../../utils';
import { now } from '../../../utils-date';
import { Menu } from './Menu';

const StyledMenuList = styled(MenuList)`
  margin: 0;
  padding: 0;
`;

const StyledMenuItem = styled(MenuItem)`
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  & .Mui-selected {
    background-color: rgb(0, 150, 153);
  }
`;

const StyledDivider = styled(Divider)`
  font-weight: 800;

  & .MuiDivider-wrapper {
    margin: 0;
    padding: 0;
  }
  & ::before,
  & ::after {
    border-top: 1px solid white;
  }
`;

const StyledChip = styled(Chip)`
  margin: 0;
  color: white;
  border: white;

  & .MuiChip-label {
    padding: 0;
  }
`;

const menuLabel = (label: string) => `common:timeSlider.presets.${label}`;

export const PresetPicker = () => {
  const { t } = useTranslation();
  const timeSliderHandle = useGlobalTimeSliderContext();
  const [state, dispatch] = timeSliderHandle;
  const granularityInfoKeys = enumKeys(state.granularityInfo);
  return (
    <Menu label={'Presets'}>
      {granularityInfoKeys.map((granularity) => {
        const info = state.granularityInfo[granularity];
        return (
          <StyledMenuList key={granularity}>
            <StyledDivider textAlign="left">
              <StyledChip
                label={t(`common:timeSlider.steps.${info.granularity.label}`)}
                size="small"
                variant="outlined"
              />
            </StyledDivider>
            {info.availablePresets.map((preset) => (
              <StyledMenuItem
                key={`preset-picker-${preset.id}`}
                onClick={() =>
                  dispatch({
                    type: 'update-preset',
                    granularity: info.granularity,
                    preset,
                    current: now(),
                  })
                }
                style={{ color: 'inherit' }}
              >
                {t(menuLabel(preset.label))}
              </StyledMenuItem>
            ))}
          </StyledMenuList>
        );
      })}
    </Menu>
  );
};
